<button
  class="sso-button d-flex flex-row ion-align-items-center ion-justify-content-start h-100 w-100"
  [class.sso-button-minimal]="isMinimal"
  [attr.data-testId]="testId"
  (click)="onClick()"
>
  <img class="me-3 social-icon" [class.social-icon-minimal]="isMinimal" [src]="imageSrc" alt="" />
  <span [class.d-lg-none]="isMinimal">{{ text }}</span>
</button>
